import type RetentionPolicyTag from 'owa-service/lib/contract/RetentionPolicyTag';
import type { HierarchyRetentionPolicyTag } from './createHierarchialSubMenuDeleteItem';

export default function buildHierarchyPolicyTags(
    retentionPolicyTagList: RetentionPolicyTag[]
): HierarchyRetentionPolicyTag[] {
    const hierarchyIndex = {};
    // RetentionId is the label Guid
    // Parent Label Identity is the parent retention id
    // Add root tags.
    const hierarchyPolicyTags = retentionPolicyTagList
        .filter(
            (tag: RetentionPolicyTag) =>
                tag.ParentLabelIdentity == null || tag.ParentLabelIdentity.length <= 0
        )
        .reduce((acc: HierarchyRetentionPolicyTag[], tag: RetentionPolicyTag) => {
            const hierarchyTag = { parentPolicyTag: tag, childrenPolicyTags: [] };
            acc.push(hierarchyTag);
            hierarchyIndex[tag.RetentionId] = hierarchyTag;
            return acc;
        }, []);

    // Add children tags
    retentionPolicyTagList
        .filter(
            (tag: RetentionPolicyTag) =>
                tag.ParentLabelIdentity != null &&
                tag.ParentLabelIdentity.length > 0 &&
                tag.ParentLabelIdentity in hierarchyIndex
        )
        .forEach((tag: RetentionPolicyTag) => {
            // Update the children policy tags of the hierarchy tag
            const hierarchyTag = hierarchyIndex[tag.ParentLabelIdentity];
            hierarchyTag.childrenPolicyTags.push(tag);
        });
    return hierarchyPolicyTags;
}
